import { ConcreteEncodable } from "./ConcreteEncodable";

import { UserProfileChangeRequestImplEncoder } from "../../encoder/UserProfileChangeRequestImplEncoder";

import * as CubiqTS from "../../index";
import { UserProfileChangeRequest } from "../UserProfileChangeRequest";

export class UserProfileChangeRequestImpl
  extends ConcreteEncodable
  implements UserProfileChangeRequest
{
  public static enType: string = "com.bcdfx.model.event.UserProfileChangeRequestImpl";

  /*FID=1*/
  public userCd: string;
  /*FID=2*/
  public profileName: string;
  /*FID=3*/
  public isUserProfileFg: boolean;
  /*FID=100*/
  public messageId: string;
  /*FID=200*/
  public brokerId: string;
  /*FID=300*/
  public secureToken: CubiqTS.SecureToken | null = null;
  /*FID=999*/
  public proxySessionId: string;
  /*FID=10000*/
  public svrRxTime: CubiqTS.Long | null = null;
  /*FID=10001*/
  public svrTxTime: CubiqTS.Long | null = null;
  /*FID=10002*/
  public cliTxTime: CubiqTS.Long | null = null;
  /*FID=10003*/
  public cliRxTime: CubiqTS.Long | null = null;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = UserProfileChangeRequestImplEncoder.Instance;
    this.setEncodableType(UserProfileChangeRequestImpl.enType);
    this.messageId = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
      let r = (Math.random() * 16) | 0,
        v = c == "x" ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }

  public toString(): string {
    return (
      "UserProfileChangeRequestImpl[" +
      "userCd=" +
      this.userCd +
      "profileName=" +
      this.profileName +
      "isUserProfileFg=" +
      this.isUserProfileFg +
      "messageId=" +
      this.messageId +
      "brokerId=" +
      this.brokerId +
      "secureToken=" +
      this.secureToken +
      "proxySessionId=" +
      this.proxySessionId +
      "svrRxTime=" +
      this.svrRxTime +
      "svrTxTime=" +
      this.svrTxTime +
      "cliTxTime=" +
      this.cliTxTime +
      "cliRxTime=" +
      this.cliRxTime +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
